import { returnFormattedDate } from "@/lib/globalFormatterHelper";

/**
 * Format delivery date value for display.
 */
export function formatDeliveryDate(value: any): string {
  if (!value) return "";
  return returnFormattedDate(value);
}

/**
 * AG Grid valueFormatter for copy/paste.
 * Returns formatted date with trailing space per project convention.
 */
export function deliveryDateValueFormatter(params: any): string {
  if (!params.value) return "";
  return `${returnFormattedDate(params.value)} `;
}
